import { Alert } from "@material-ui/lab";
import { Slide, Snackbar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { toastEnd } from "../../actions/toastAction";

const Toast = (props) => {
  const { message, severity, snakeOpen } = props;
  const dispatch = useDispatch();
  const [transaction, setTransaction] = useState();

  useEffect(() => {
    setTransaction(() => SlideTransition);
  }, []);

  const closeSnackbarHandle = () => {
    dispatch(toastEnd());
  };

  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snakeOpen}
        autoHideDuration={3000}
        onClose={closeSnackbarHandle}
        TransitionComponent={transaction}
      >
        <Alert elevation={6} variant="filled" severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    message: state.toast.message,
    severity: state.toast.severity,
    snakeOpen: state.toast.snakeOpen,
  };
};
export default connect(mapStateToProps)(Toast);
